import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  // 根据环境变量设置 baseURL，如果没有设置则使用默认地址
  // baseURL: '/api',
  baseURL: '/prod-api',
  timeout: 10000 // 增加请求超时时间到10秒
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    console.log('发送请求:', config.baseURL + config.url)
    
    const token = localStorage.getItem('access_token') // 从 localStorage 获取 token
    if (token) {
      // 让每个请求携带 token
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    
    // 根据返回的状态码进行处理
    if (res.code === 200) {
      return res
    } else {
      // 其他错误码处理
      console.log('响应错误:', res.message)
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    // 对响应错误做点什么
    console.log('响应错误:' + error)
    
    // 网络错误处理
    if (!error.response) {
      console.log('网络错误，请检查服务器是否运行以及网络连接是否正常')
    }
    
    return Promise.reject(error)
  }
)

export default service